function closeAllSidebars() {
    $('.sidebar').addClass('_close');
}

function toggleSidebarBackdrop(state) {
    if(state) {
        $('html, body').addClass('sidebar_open');
        $('.js-overlay').addClass('_active');
    }
    else {
        $('html, body').removeClass('sidebar_open');
        $('.js-overlay').removeClass('_active');
    }
}

function openSidebar(target) {
    target.removeClass('_close');
}

function initSidebar() {
    const reviewSidebars = $('.sidebar._review');
    const reviewButtons = $('[data-target=review]');

    $(document).on('click', '.sidebar-close, .js-overlay', function() {
        $('html, body').removeClass('sidebar_open');
        $('.sidebar').addClass('_close');
        $('.sidebar-button').removeClass('_open').addClass('_close');
        $('.js-overlay').removeClass('_active');
    });
    
    $(document).on('click', '.sidebar-button', function(e) {
        e.preventDefault();
        if ($(this).hasClass('_open')) {
            $('.sidebar-button_menu').toggleClass('_open _close');
            closeAllSidebars();
            

            toggleSidebarBackdrop(false);
            $('.sidebar-button_service, .sidebar-button_winkels, sidebar-button_language').addClass('_open');
        } else {
            let sidebar = '._' + $(this).data('target');
            $('.sidebar-button_menu').toggleClass('_close _open');
            closeAllSidebars();
            $('.sidebar-button_service, .sidebar-button_winkels, sidebar-button_language').removeClass('_open');
            
            if ($(this).hasClass('pdp-outlet')) {
                const STORE_IMAGE = $(this).attr('data-image');
                const STORE_NAME = $(this).attr('data-name');
                const STORE_ID = $(this).attr('data-id');
                const STORE_LINK = $(this).attr('data-link');
                const STORE_ADDRESS = $(this).attr('data-address');
                
                if ($(this).hasClass('_outletoverview')) {
                    const select = document.querySelector('[data-js="toggle-shops"]');
                    const STORES = $(this).parent().parent().parent().find('[data-js="store-names"]').attr('data-stores');
                    const STORES_PARSED = JSON.parse(STORES);
                    STORES_PARSED.map(item => {
                        let opt = document.createElement('option');
                        opt.id = item;
                        opt.value = item.replaceAll(' ', '-').toLowerCase();
                        opt.innerHTML = item;
                        select.appendChild(opt);
                    });

                    setTimeout(() => {
                        $(sidebar).find(`option[id="${STORE_NAME}"]`).prop('selected', true);
                    }, 100);
                }

                $(sidebar).find('.store-image').attr('src', STORE_IMAGE);
                $(sidebar).find('.store-image').attr('alt', STORE_NAME);
                $(sidebar).find('.store-name').text(STORE_NAME);
                $(sidebar).find('.btn-sidebar-menu').attr('href', STORE_LINK);
                $(sidebar).find('.address').text(STORE_ADDRESS);
                $(sidebar).find('.in').removeClass('in');
                $(sidebar).find(`option`).prop('selected', false);
                $(sidebar).find(`option#outlet-${STORE_ID}`).prop('selected', true);
            }

            if ($(this).hasClass('stofstaal-modal-button')) {
                const STOFSTAAL_NAME_UNPARSED = $(this).attr('data-names');
                const STOFSTAAL_CODE_UNPARSED = $(this).attr('data-codes');

                const STOFSTAAL_NAME = JSON.parse(STOFSTAAL_NAME_UNPARSED).join(', ');
                const STOFSTAAL_CODE = JSON.parse(STOFSTAAL_CODE_UNPARSED).join(', ');

                $(sidebar).find('[data-js-stofstaal-name]').text(STOFSTAAL_NAME);
                $(sidebar).find('[data-js-stofstaal-code]').text(STOFSTAAL_CODE);
                $(sidebar).find('input[name="1stofstaal_name"]').val(STOFSTAAL_NAME);
                $(sidebar).find('input[name="2stofstaal_value"]').val(STOFSTAAL_CODE);

            }

            if($(this).hasClass('show_data') && $(this).attr('data-url')) {
                modalFillContent($(sidebar), $(this).data('url'));
                if($(this).find('.rating-input')) {
                    $('.rating-input').rating({
                        min: 0,
                        max: 5,
                        step: 1,
                        size: 'xs',
                        showClear: false,
                        showCaption: false
                    });
                }
            }

            if ($(this).attr('data-title')) {
                $(sidebar).find('.title').html($(this).attr('data-title'));
            }

            if ($(this).attr('data-content')) {
                var $this = $(this),
                content = $this.data('content'),
                img = $this.data('img');
        
                if (img) {
                    content = '<div class="row"><div class="col-xs-12">' + content + '</div><div class="col-xs-12 mt-2"><img src="' + img + '" class="img-responsive"></div></div>';
                } else {
                    content = '<div class="row"><div class="col-xs-12">' + content + '</div></div>';
                }

                $(sidebar).find('.sidebar-main .content').html(content);
            }

            if ($(sidebar).find('[name="return_url"]') && $(this).attr('data-return-url')) {
                $('[name="return_url"]').val($(this).attr('data-return-url'));
            }

            if ($(sidebar).hasClass('_stofstaal')) {
                $(sidebar).find('#stofstaal-div').removeClass('hidden');
                $(sidebar).find('#stofstaal-result').addClass('hidden');
            }

            openSidebar($(sidebar));
            toggleSidebarBackdrop(true);
        }

    });
    
    if(reviewSidebars.length && reviewButtons.length) {
        modalFillContent($(reviewSidebars), $(reviewButtons).data('url'));
    }

    $('.shopmenu-subcontent-subcontent ul').length > 0 && $('.shopmenu-subcontent-subcontent ul').offset() ? $('.shopmenu-subcontent-subcontent ul').css('width', `calc(100vw - ${$('.shopmenu-subcontent-subcontent ul').offset().left}px)`) : null;
}

function modalFillContent(modal, url) {
    $.get(url, {}, function(data) {
        if(typeof data == 'object') {
            modal.find('#xhr-content').html(data.html);
        } else {
            modal.find('.content').html(data);
        }
    }).then(function(){
        $('.rating-input').rating({
            min: 0,
            max: 5,
            step: 1,
            size: 'xs',
            showClear: false,
            showCaption: false
        });
    });
}

$(document).on('click', '[data-toggle=toggle]', function() {
    const target = $(this).attr('data-target');
    $(target).toggle('fast');
})

$(document).on('click', '#basket-modal .nav-tabs li a', function(e) {
    if($(this).attr('href') === '#basket-content' && $(this).parent().hasClass('active')) {
        $('.modal-footer-sub').show()
    } else {
        $('.modal-footer-sub').hide()
    }
});

const bodyEl = document.querySelector('._base-content_');

const applyNoScrollBody = (e) => {
    e.preventDefault();
    e.stopPropagation();
}

const _applyNoScrollBody = () => {
    bodyEl.addEventListener('wheel', applyNoScrollBody, {passive: false});
};

const _applyScrollBody = () => {
    bodyEl.removeEventListener('wheel', applyNoScrollBody);
}

$(document).on('shown.bs.modal', _applyNoScrollBody)
$(document).on('hidden.bs.modal', _applyScrollBody)

const videoSidebar = () => {
    const videoPlayer = document.querySelectorAll('[data-js="video-player"]');
    const config = { attributes: true, childList: true, characterData: true };

    videoPlayer.forEach(function(item) {
        var target = item.parentNode.parentNode.parentNode;
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (target.classList.contains('_close')) {
                    const videoIframe = item.querySelector  ('iframe');
                    const url = videoIframe.getAttribute('src');
                    videoIframe.setAttribute('src', '');
                    videoIframe.setAttribute('src', url);
                }
            });
        });
    
        observer.observe(target, config);

    });

}

defer(initSidebar, videoSidebar());